<template>
  <footer class="footer-fitsi text-white pt-5 pb-4 m-0" id="contacto">
    <div class="container-fluid px-3 px-lg-5">
      <div class="row g-4 align-items-start">
        
        <!-- Columna 1: Mapa de Google (Como en Fitgym) -->
        <div class="col-12 col-lg-4 order-2 order-lg-1">
          <div class="map-wrapper rounded-4 overflow-hidden shadow-lg border border-secondary border-opacity-25">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d930.3674593802618!2d-86.85617427280953!3d21.13369258956276!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8f4c2b0f8406a891%3A0x85bcf77f22d87d4f!2sThe%20Fit%20Bar!5e0!3m2!1ses!2smx!4v1655999946812!5m2!1ses!2smx"
              width="100%"
              height="340px"
              style="border:0;"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>

        <!-- Columna 2: Información de Contacto (Como en Fitgym) -->
        <div class="col-12 col-lg-4 order-1 order-lg-2 contacto-col px-lg-4">
          <h3 class="footer-title text-white mb-2">
            THE FIT <span class="text-naranja">BAR</span>
          </h3>
          <p class="text-white-50 fs-6 mb-3">
            Comida saludable y gourmet en Cancún.
          </p>

          <div class="schedule-box p-3 rounded-3 mb-3">
            <h6 class="text-uppercase fw-bold text-naranja mb-2">Horario de Cocina:</h6>
            <p class="m-0 text-white-50 small"><strong>Lunes a Viernes:</strong> 7:00 hrs a 20:00 hrs</p>
            <p class="m-0 text-white-50 small"><strong>Sábados:</strong> 7:00 hrs a 16:00 hrs</p>
          </div>

          <p class="telefono-link mb-2">
            <a
              href="https://wa.me/529983641651"
              target="_blank"
              rel="noopener noreferrer"
              class="text-white text-decoration-none d-inline-flex align-items-center gap-2 fw-bold"
            >
              <img :src="require('@/assets/img/whatsapp_blanco.png')" width="24" alt="WhatsApp" />
              (998) 364 1651
            </a>
          </p>

          <p class="address-text text-white-50 small mb-3">
            Plaza Zafiro, Av. Las Torres Smz 509, Av. Kinik, La Luna, 77533 Cancún, Q.R.
          </p>
        </div>

        <!-- Columna 3: Galería Fitbar (Al lado de Maps, como Estacionamiento en Fitgym) -->
        <div class="col-12 col-lg-4 order-3 order-lg-3">
          <div class="parking-wrapper p-3 rounded-4">
            <GaleriaWidget />
          </div>
        </div>

      </div>

      <!-- Botón Scroll to Top estilo Fitgym: PERFECTAMENTE CENTRADO EN MEDIO -->
      <div class="footer-top-scroll-container">
        <button @click="scrollToTop" class="btn-scroll-top-fitsi" title="Subir al inicio" aria-label="Subir al inicio">
          <i class="bi bi-arrow-up"></i>
        </button>
      </div>

      <!-- Copyright inferior estilo Fitgym -->
      <div class="row pt-3 border-top border-secondary border-opacity-25 text-center text-white-50 small">
        <div class="col-12 d-flex flex-column flex-sm-row justify-content-between align-items-center gap-2">
          <span>© {{ currentYear }} The Fit Bar Cancún. Todos los derechos reservados.</span>
          <a
            href="#"
            @click.prevent="scrollToTop"
            class="text-white-50 text-decoration-none hover-naranja"
          >
            Aviso de Privacidad
          </a>
        </div>
      </div>

    </div>
  </footer>
</template>

<script>
import GaleriaWidget from "./GaleriaWidget.vue";

export default {
  name: "Contacto",
  components: {
    GaleriaWidget,
  },
  data() {
    return {
      currentYear: new Date().getFullYear(),
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    },
  },
};
</script>

<style scoped>
.footer-fitsi {
  background-color: #0d0d0d;
  background-image: linear-gradient(180deg, #0a0a0a 0%, #111111 100%);
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.footer-title {
  font-family: 'Montserrat', sans-serif;
  font-weight: 900;
  font-size: 2.2rem;
  letter-spacing: -0.01em;
  text-transform: uppercase;
}

.text-naranja {
  color: #fd6f3c !important;
}

.schedule-box {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.parking-wrapper {
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.hover-naranja:hover {
  color: #fd6f3c !important;
}

@media (max-width: 991px) {
  .contacto-col {
    text-align: center;
  }
  .schedule-box {
    max-width: 360px;
    margin-left: auto;
    margin-right: auto;
  }
  .footer-title {
    font-size: 1.85rem;
  }
}

/* ====================================================================
   Botón para Subir al Inicio estilo Fitgym: EXACTAMENTE EN EL MEDIO
   ==================================================================== */
.footer-top-scroll-container {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  width: 100% !important;
  margin-top: 3.5rem;
  margin-bottom: -26px; /* Queda montado exactamente a la mitad sobre la línea divisoria */
  position: relative;
  z-index: 20;
}

.btn-scroll-top-fitsi {
  width: 52px;
  height: 52px;
  background-color: #fd6f3c;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.45rem;
  font-weight: 900;
  cursor: pointer;
  box-shadow: 0 4px 18px rgba(253, 111, 60, 0.55);
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.btn-scroll-top-fitsi:hover {
  background-color: #ffffff;
  color: #fd6f3c;
  transform: translateY(-4px) scale(1.08);
  box-shadow: 0 8px 25px rgba(253, 111, 60, 0.8);
}
</style>
